export const hdmgdjFaqs = [
  {
    id: "q-what",
    q: "黄豆魔改短剧是什么？",
    a: "黄豆魔改短剧是一款主打经典影视二次创作的短剧应用，把大家熟悉的桥段用全新的脑洞重新演绎，反转密集、节奏明快，观看体验轻松上头。",
  },
  {
    id: "q-platform",
    q: "黄豆魔改短剧APP下载支持哪些平台？",
    a: "我们提供 Android、iOS、HarmonyOS 与 Windows 四个平台的安装包，在下载页选择对应版本即可一键获取，安装后登录同一账号即可多端同步观看进度。",
  },
  {
    id: "q-free",
    q: "黄豆魔改短剧免费版下载后真的免费吗？",
    a: "是的。黄豆魔改短剧免费版下载后即可畅看海量剧场内容，无需额外付费，也没有强制弹窗广告，打开就能直接追剧。",
  },
  {
    id: "q-install",
    q: "下载安装后打不开怎么办？",
    a: "请先确认系统版本符合要求（Android 6.0 及以上、iOS 13.0 及以上、HarmonyOS 3.0 及以上、Windows 10 及以上）。若仍无法打开，可卸载后重新下载安装包，或通过页面底部邮箱联系我们。",
  },
  {
    id: "q-login",
    q: "使用黄豆魔改短剧需要注册登录吗？",
    a: "基础观看无需注册即可体验。登录后可以收藏剧目、同步观看记录、享受跨设备续看，建议注册一个账号获得完整体验。",
  },
  {
    id: "q-smooth",
    q: "观看时出现卡顿怎么办？",
    a: "建议在 Wi-Fi 环境下观看，或在播放页手动切换到流畅画质；也可以先离线缓存整部短剧，缓存完成后即便弱网环境也能顺畅播放。",
  },
];